module.exports = __webpack_public_path__ + "img/2.a0b31648.png";